import React from 'react';
import { Typography } from "antd";

const { Title, Text } = Typography;

export const PageHeader = ({ title, description }) => {
  return (
    <div style={{ marginBottom: '24px' }}>
      <Title level={3} style={{ margin: 0, fontWeight: 700 }}>
        {title}
      </Title>
      <Text type="secondary" style={{ fontSize: '15px' }}>
        {description}
      </Text>
    </div>
  );
};
